import React, { useEffect, useState } from 'react'
import Layout from '../../Layout/Layout'


import HomeSection3 from './HomeSection3'

import HomeSection5 from './HomeSection5'

import Footer from '../../Layout/Footer'
import HomeSection4 from './HomeSection4'
import HomeSection11 from './HomeSection11'
import HomeSection12 from './HomeSection12'
import HomeSection14 from './HomeSection14'
import HomeSection13 from './HomeSection13'
import HomeSection15 from './HomeSection15'
import HomeSection16 from './HomeSection16'
import HomeSection17 from './HomeSection17'
import HomeSection18 from './HomeSection18'
// import HomeSection2 from './HomeSection2'
// import HomeSection111 from './HomeSection111'
import HomeSection112 from './HomeSection112'
import HomeBanners from './HomeBanners'
import BannersCarousel from './BannersCarousel'
import HomeStatistics from './HomeStatistics'
import HomeProducts from './HomeProducts'
import HomeOffers from './HomeOffers'
import HomeCollection from './HomeCollection'
import Medicine from './Medicine'
import BannerAPI1 from './BannerAPI1'
import HomeDynamicProducts from './HomeProductsDynamic'
import FooterCalendar from '../../Layout/FooterCalendar'
import FooterNew from '../../Layout/FooterNew'
import SEO from '../../SEO'
import axios from 'axios'
// import FunctionCart from './HomeSection51'

const BASE_URL = "https://ecom.cyberathon.com/index.php/Api";
function Home() {
   const [seoData, setSeoData] = useState({});

   useEffect(() => {
    const fetchSeo = async () => {
      try {
        const response = await axios.post(`${BASE_URL}/get_seo_by_page`, { page_name: 'home' });

        if (response.data.status === 'true') {
          const data = response.data.data;
          setSeoData({
            title: data.meta_title,
            description: data.meta_description,
            keywords: data.meta_keywords,
            canonical: data.canonical_url,
          });
        }
      } catch (error) {
        console.error('SEO fetch error:', error);
      }
    };

    fetchSeo();
  }, []);
  return (
    <>
    <SEO
      title={seoData.title || "Shopeindia | Aesthetic Machines & Cupping Therapy Supplies"}
      description={seoData.description || "ShopIndia is the best online shopping platform..."}
      keywords={seoData.keywords || "ShopIndia, online shopping, electronics, clothes, medicines"}
      canonical={seoData.canonical || "https://www.shopindia.com/"}
    />
      <div>
        <Layout/>
        {/* <HomeSection11/>  real one */}
        {/* <HomeSection112/> */}
        <HomeBanners/>
        {/* <BannerAPI1/> */}
        {/* <BannersCarousel/> */}
        <HomeSection12/>
        {/* <HomeSection4/> real one */}
        <HomeOffers/>
        {/* <HomeSection5/>  real one*/}
        <HomeStatistics/>
        {/* <FunctionCart/> */}
        {/* <HomeSection13/> real one */}
        <HomeCollection/>
        {/* <HomeSection2/> */}
        {/* <HomeSection14/> */}
        {/* <HomeProducts/> */}
        {/* <HomeSection15/> */}
        {/* <HomeSection16/> */}
        {/* <HomeSection17/> */}
        {/* <HomeSection18/> */}
        <HomeDynamicProducts/>
        {/* <HomeSection3/> */}
        <Medicine/>
        {/* <Footer/> */}
       {/* <FooterCalendar/> */}
       <FooterNew/>
      </div>
    </>
  )
}

export default Home


